import React from "react";
import ReactDOM from "react-dom";
import moment from "moment";
import { connect } from "react-redux";
import { Scheduler, Button, Popup, ValidationGroup } from "devextreme-react";
import { CuposItem } from "../cuposItem";
import TextField from "../../../../../Shared/fields/TextField";
import { setBlocking, setStepWizard, doCreateUpdateBlocking, setNameConflictModal, setDataPage, setConfigShedulerWizard, doGetOpeningData, createBlock, editBlock } from "../actions";
import TooltipBody from "./TooltipBody";
import LoadingOverlay from "../../../../../Shared/LoadingOverlay";
import validaciones from "../../../../../../helpers/validaciones";
import BlockingValidation from "./blockingValidation";
class formMatrizApertura extends React.PureComponent {
  constructor(props) {
    super(props);
    this.data = null;
    this.lastTimeInterval = "";
  }

  componentDidMount = () => {
    if(this.props.blocking.isNewConfig === true){
      this.props.dispatch(doGetOpeningData(this.props.centerId, moment(this.props.blocking.startDate).format("YYYY-MM-DD"), moment(this.props.blocking.endDate).format("YYYY-MM-DD")))
    }else{
      //this.setDataMatriz()
    }
    //this.setDataMatriz()
    //CreateBlock
    //UpdateBlock
    //DeleteBlock
  }

  componentWillUnmount = () => {
    if(this.props.connectionHub)
      this.props.connectionHub.off('schedulingReceived')
  }

  componentDidUpdate = (prev) => {
    if(prev.blocking.blockingData !== this.props.blocking.blockingData){
      this.setDataMatriz(true)
    }
    if(prev.blocking.dataPage !== this.props.blocking.dataPage){
      this.setDataMatriz(true)
    }
  }

  enumerateDaysBetweenDates = (data) => {
    var dates = [];
    var weeks = []
    var currDate = moment(data.startDate).startOf('day');
    var lastDate = moment(data.endDate).startOf('day');

    while(currDate.diff(lastDate) <= 0) {
      let pivot = validaciones.getDaysByOrder(currDate.format("E"))
      let _obj = {
        date: currDate.clone().toDate(),
        dayWeek: {
          day: pivot.name,
          id: pivot.index,
          order: pivot.order,
          date: currDate.format()
        }
      }
      dates.push(_obj);
      if(pivot.index === 0){
        weeks.push(dates)
        dates = [];
      }
      currDate.add(1, 'days')
    }
    if(dates.length > 0){
      weeks.push(dates)
    }
    return weeks;
  };

  createPriority = (workDays) => {
    const priorityData = [];
    workDays.forEach((item) => {
      // Configuracion de la matriz
      const pivot = validaciones.getDaysIndex(item.day);
      priorityData.push({
        text: validaciones.capitalizeFirstLetter(pivot.name),
        id: pivot.index,
        order: pivot.order,
      });
    });
    return priorityData.sort((a, b) => a.order - b.order);
  }

  createQuoteMatrix = (workDays, blocking) => {
    let blockingData = blocking.blockingData;
    let timeStep = blocking.timeStep;
    let BlockAll = blocking.BlockAll;
    let data = [];
    workDays.forEach((item) => {
      data = [...data, ...blockingData.map(e => {
        let start = this.concatDateAndTime(item.date, moment(e.StartTime, "HH:mm:ss").format("HH:mm"));
        let end = this.concatDateAndTime(item.date, moment(e.EndTime, "HH:mm:ss").format("HH:mm"));

        let startInt = this.concatDateAndTime(new Date(), moment(e.StartTime, "HH:mm:ss").format("HH:mm"));
        let endInt = new Date(startInt.getTime() + (parseInt(timeStep, 10) * 60 * 1000));

        let _quota = e.BlocDateDetails.find(ee => moment(ee.SchedulingDate).isSame(moment(item.date).startOf("day")))
        let _quotaDetail = (det) => {
          if(!det) return null;
          if(BlockAll){
            let _det = det.map(d => {
              d.QuantityQuotasBlocked = d.QuantityQuotaAvailable;
              d.QuantityOverQuotasBlocked = d.QuantityOverQuotaAvailable;
              d.QuantityQuotaBlocked = d.QuantityQuotaAvailable;
              d.QuantityOverQuotaBlocked = d.QuantityOverQuotaAvailable;
              d.QuantityQuotaAvailable = 0;
              d.QuantityOverQuotaAvailable = 0;
              return {...d}
            })
            return [..._det]
          }else{
            return det;
          }
        }
        return {
          day: item.order || (item.index === 0 ? 7 : item.index),
          startDate: start,
          endDate: end,
          startDateInt: startInt.setHours(moment(startInt).hour(), moment(startInt).minutes(), 0, 0),
          endDateInt: endInt.setHours(moment(endInt).hour(), moment(endInt).minutes(), 0, 0),
          Quotas: _quota && _quotaDetail(_quota.OpeningQuotaDetails)
        };
      })]
    });
    return data;
  }

  concatDateAndTime = (date, time) => {
    const soloFecha = moment(new Date(date), "DD-MM-YYYY").format("DD-MM-YYYY");
    const soloHora = moment(time, "HH:mm").format("HH:mm");
    const fechaHora = `${soloFecha} ${soloHora}`;
    return new Date(moment(fechaHora, "DD-MM-YYYY HH:mm").format("MM-DD-YYYY HH:mm"));
  }

  getTimeAsFloat = (time, isMax) => {
    let totalHour = isMax ? parseInt(moment.max(time).format("HH")) : parseInt(moment.min(time).format("HH"));
    const minutes = isMax ? parseInt(moment.max(time).format("mm")) : parseInt(moment.min(time).format("mm"));

    if (minutes === 15) { totalHour += 0.25; }
    if (minutes === 30) { totalHour += 0.5; }
    if (minutes === 45) { totalHour += 0.75; }
    return totalHour;
  }

  setDataMatriz = (updateMatriz) => {
    const newBlocking = { ...this.props.blocking };
    if(newBlocking.blockingData && newBlocking.blockingData.length){
      let _datesArr = this.enumerateDaysBetweenDates(newBlocking)
      newBlocking.dataPageLength = _datesArr.length;
      newBlocking.timeStep = newBlocking.blockingData[0].ModuleDuration;
      const workDays = _datesArr[newBlocking.dataPage].map(e => e.dayWeek);//indicar posicion de la matriz
      newBlocking.pagerStartDate = new Date(workDays[0].date);
      if (newBlocking.oldData != null) newBlocking.data = newBlocking.oldData;
      let completeData = [];
      const priorityData = this.createPriority(workDays);

      if ((newBlocking.IdConfig === 0 && newBlocking.data.length === 0) || updateMatriz) {
        for (let i = 0; i < newBlocking.dataPageLength; i++) {
          let _workDay = _datesArr[i].map(e => e.dayWeek);
          completeData.push(this.createQuoteMatrix(_workDay, newBlocking))
        }
        //data = completeData[newBlocking.dataPage];
        newBlocking.data = [...completeData[newBlocking.dataPage]];
        newBlocking.completeData = completeData;
      }else  if (newBlocking.IdConfig > 0 || newBlocking.completeData.length) {
        // ciclo para crear la matriz para un nuevo bloqueo desde una configuracion historica
        newBlocking.data = [...newBlocking.completeData[newBlocking.dataPage]];
      }
      if (newBlocking.data && newBlocking.data.length) {
        newBlocking.oldData = [...newBlocking.data];
      }

      if(newBlocking.data.length){
        const momentsMax = newBlocking.data.map((d) => moment(d.endDate));
        const momentsMin = newBlocking.data.map((d) => moment(d.startDate));
        const config = {
          startDayHour: this.getTimeAsFloat(momentsMin, false),
          endDayHour: this.getTimeAsFloat(momentsMax, true),
          cellDuration: parseInt(newBlocking.timeStep, 10),
        };
        newBlocking.priorityData = priorityData;
        this.props.dispatch(setConfigShedulerWizard(config));
        this.props.dispatch(setBlocking(newBlocking));
      }
    }

  }

  handleBack = () => {
    this.props.dispatch(setStepWizard({
      stepOne: true,
      stepTwo: false,
      stepThree: false,
      stepSuccess: false,
    }));
  }

  openCloseModal = (value) => {
    this.props.dispatch(setNameConflictModal(value));
  }
  handleOpenName = () => {

  }
  handleClose = () => {
    this.openCloseModal(false);
  }

  handleChangeNameOpeninig = (e) => {
    const NewBlocking = { ...this.props.blocking };
    NewBlocking.NameBlocking = e.value;

    this.props.dispatch(setBlocking(NewBlocking));
  }

  handleAppointmentClick = (event) => {
    if(this.props.blocking.BlockAll) event.cancel = true;
    this.data = event.appointmentData;
  }

  handleEnd = (params) => {
    const result = params.validationGroup.validate();
    if(result.isValid){
      this.sendData();
    }
  }

  nameValidation = (e) => {
    if (e.value !== null) {
      return true;
    }

    return false;
  }

  handleCreateBlock = () => {

    const NewBlocking = { ...this.props.blocking };
    let arr = [];
    let obj = {};
    obj.Id = NewBlocking.isNewConfig ? null : NewBlocking.Id;
    obj.OfficeId = this.props.centerId;
    obj.BlockName = NewBlocking.NameBlocking;
    obj.BlockAll = NewBlocking.BlockAll;
    obj.BlockingReasonId = NewBlocking.BlockingReasonId;
    obj.BlockComment = NewBlocking.comment;
    obj.CreationDate = moment(new Date()).format();
    obj.BlockUserRut = this.props.userData.RUT;

    var currDate = moment(NewBlocking.startDate).startOf('day');
    var lastDate = moment(NewBlocking.endDate).startOf('day');

    let completeData = []

    NewBlocking.completeData.forEach(element => {
      let data = element.filter(e => e.Quotas && e.Quotas.length && e.Quotas.find(ee => ee.QuantityQuotasBlocked || ee.QuantityOverQuotasBlocked));
      completeData = [...completeData, ...data];
    });

    while(currDate.diff(lastDate) <= 0) {
      let _data = [];
      let _end = moment(currDate.startOf("day").format());
      completeData.forEach(d => {
        if(moment(d.startDate).startOf("day").isSame(_end)){
          let _quotaFiltered = d.Quotas.filter(q => q.QuantityQuotasBlocked || q.QuantityOverQuotasBlocked )
          _data = [..._data, ..._quotaFiltered]
        }
      })
      if(_data && _data.length){
        arr.push({
          ...obj,
          BlockDate: currDate.format(),
          OpeningQuota: _data
        })
      }
      currDate.add(1, 'day')
    }
    if(NewBlocking.isNewConfig){
      this.props.dispatch(createBlock(arr, this.props.connectionHub))
    }else if(arr.length){
      this.props.dispatch(editBlock(arr[0], this.props.connectionHub))
    }
  }

  renderTooltipBodyBlocking = (appointment) => <TooltipBody data={appointment} />

  renderNameBlocking = () => {
    const NewBlocking = { ...this.props.blocking };
    return (

      <ValidationGroup className="row">
        <div className="col-12">
          <TextField
            label="Nombre de el bloqueo"
            required
            maxLength={80}
            id="NameBlocking"
            onChange={this.handleChangeNameOpeninig}
            value={NewBlocking.NameBlocking}
            customRules={{
              type: "custom",
              validationCallback: this.nameValidation,
              message: "El nombre es requerido",
            }}
          />
        </div>
        <div className="button-row">
          <div>
            <Button
              onClick={this.handleClose}
              text="cerrar"
            />
          </div>
          <div>
            <Button
              onClick={this.handleEnd}
              type="success"
              text="Agregar"
            />
          </div>
        </div>
      </ValidationGroup>
    );
  }

  renderWeekItem = (data, index, element) => {
    if (!data.Quotas) return;
    ReactDOM.render(
      <CuposItem data={data} />
      , element
    );
  }

  render() {
    const {
      validationBlocking,
    } = this.props;
    return (
      <div
        style={{ height: 410 }}
      >
        <div style={{ height: "100%" }}>
          {this.props.isLoading && <LoadingOverlay />}
          <div className="row"  style={{height: "100%"}}>
            <div className="col-1 zero" style={{display: "flex"}}>
              <Button
                style={{margin: "auto"}}
                icon={'chevronprev'}
                disabled={this.props.blocking.dataPage === 0}
                onClick={()=>this.props.dispatch(setDataPage(this.props.blocking.dataPage-1))} />
            </div>
            <div className="col-10" style={{height: "100%"}}>
              <Scheduler

                height={"100%"}
                className="simple-scheduler-view blocking-view-month"
                dataSource={this.props.blocking.data}
                defaultCurrentView="week"
                views={[
                  {
                    name: "day",
                    type: "week",
                    groupOrientation: "horizontal",
                    maxAppointmentsPerCell: "unlimited",
                    cellDuration: this.props.blocking.timeStep,
                    appointmentTemplate: this.renderWeekItem,
                    intervalCount: 1,
                  },
                ]}
                currentDate={this.props.blocking.pagerStartDate}
                startDayHour={this.props.config.startDayHour}
                endDayHour={this.props.config.endDayHour}
                crossScrollingEnabled
                cellDuration={this.props.blocking.timeStep}
                groups={["week"]}
                showAllDayPanel={false}
                resources={[
                  {
                    fieldExpr: "day",
                    valueExpr: "order",
                    allowMultiple: false,
                    dataSource: this.props.blocking.priorityData,
                  },
                ]}
                timeCellTemplate={(data, index, element) => {
                  let { text } = data;
                  if (data.text === "") {
                    text = validaciones.getTimeForInterval(this.lastTimeInterval, this.props.blocking.timeStep);
                  } else {
                    this.lastTimeInterval = text;
                  }
                  ReactDOM.render(<span>{text}</span>, element);
                }}
                editing={{
                  allowAdding: false,
                  allowDragging: false,
                  allowResizing: false,
                  allowUpdating: false,
                  allowDeleting: false,
                }}
                showCurrentTimeIndicator={false}
                onAppointmentDblClick={(e) => {
                  e.cancel = true;
                }}
                onAppointmentClick={this.handleAppointmentClick}
                appointmentTooltipRender={this.renderTooltipBodyBlocking}
                // onOptionChanged={(e) => {
                //   console.log(e)
                // }}
              />
            </div>
            <div className="col-1 zero" style={{display: "flex"}}>
              <Button
                style={{margin: "auto"}}
                icon={'chevronnext'}
                disabled={this.props.blocking.dataPageLength === 0 || this.props.blocking.dataPage === (this.props.blocking.dataPageLength-1)}
                onClick={()=>this.props.dispatch(setDataPage(this.props.blocking.dataPage+1))} />
            </div>
          </div>


          <div className="button-row">
            <div>
              <Button
                onClick={this.handleBack}
                text="Volver"
              />
            </div>
            <div>
              <Button
                onClick={this.handleCreateBlock}
                type="success"
                text="Finalizar"
              />
            </div>
          </div>
          <Popup
            visible={this.props.isModalNameAndConflictOpen}
            showTitle
            title={validationBlocking.openValidation === false ? "Agregar Bloqueo" : "Conflictos"}
            maxWidth={500}
            height={250}
            onHiding={this.handleClose}
            showCloseButton
            dragEnabled={false}
          >
            <div>
              {
                validationBlocking.openValidation === false ? this.renderNameBlocking() : <BlockingValidation />

              }
            </div>
          </Popup>
        </div>
      </div >
    );
  }
}

const mapStateToProps = (state) => ({
  centerSelected: state.bloqueosSel.centerSelected,
  config: state.bloqueosSel.configSchedulerWizard,
  blocking: state.bloqueosSel.blocking,
  validationBlocking: state.bloqueosSel.validationBlocking,
  isLoading: state.bloqueosSel.isLoading,
  isModalNameAndConflictOpen: state.bloqueosSel.isModalNameAndConflictOpen,
  listQuotes: state.bloqueosSel.listQuotes,
  centerId: state.bloqueosSel.centerId,
  userData: state.global.userData,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(formMatrizApertura);
